export default __webpack_public_path__ + "locales/vi/PreparationPortal.json?hash=3a302d52bd2eb8eec5cb4fa0d4b64cab";